<script lang="ts">
import { defineComponent, PropType, inject, watch } from 'vue'
import SelectorForm from '@/components/form/SelectorForm.vue'

export default defineComponent({
  name: 'SelectorIndustry',

  components: {
    SelectorForm,
  },

  props: {
    industry: {
      type: Object as PropType<InputText>,
      required: true,
    },

    namespace: {
      type: String,
      default: '',
    },

    defaultSelectorLabel: {
      type: String,
      default: '選択してください',
    },

    defaultSelectorValue: {
      type: String,
      default: '',
    },

    header: {
      type: String,
      default: '業種',
    },
  },

  emits: [
    'update:industry',
  ],

  setup(props, { emit }) {
    const INDUSTRIES = inject<string[]>('INDUSTRIES')!

    // 選択肢に存在しない値の場合は空の値で再設定
    // ※ 古いユーザの場合、古い区分で値を保持している場合があり、その場合は強制的に再設定させる。
    watch(() => props.industry.value, () => {
      if (props.industry.value && !INDUSTRIES.includes(props.industry.value)) {
        emit('update:industry', '')
      }
    })

    const emitValue = (value: string) => {
      if (typeof value === 'string') {
        emit('update:industry', value)
      } else {
        emit('update:industry', '')
      }
    }

    return {
      // constants
      INDUSTRIES,

      // methods
      emitValue,
    }
  }
})
</script>

<template>
  <SelectorForm
    :model-value="industry.value"
    :items="INDUSTRIES"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :namespace="namespace"
    :name="industry.name"
    :header="header"
    :validation-scheme="industry.validationScheme"
    @update:model-value="emitValue($event)" />
</template>
